import React from "react";
import ReactDOM from "react-dom/client";

// Suppress the benign "ResizeObserver loop" warning that ReactFlow triggers
// when nodes resize (e.g. expanding the description panel). The browser
// warning is harmless but CRA's dev overlay treats it as a hard error.
window.addEventListener("error", (e) => {
  if (e.message === "ResizeObserver loop completed with undelivered notifications." ||
      e.message === "ResizeObserver loop limit exceeded") {
    e.stopImmediatePropagation();
    // Also hide the CRA dev-server overlay if it has already appeared
    const overlay = document.getElementById("webpack-dev-server-client-overlay");
    if (overlay) overlay.style.display = "none";
    const overlayDiv = document.getElementById("webpack-dev-server-client-overlay-div");
    if (overlayDiv) overlayDiv.style.display = "none";
  }
});
import "@fontsource/inter/600.css";
import "@fontsource/outfit/300.css";
import "@fontsource/outfit/400.css";
import "@fontsource/outfit/500.css";
import "@fontsource/outfit/600.css";
import "@fontsource/outfit/700.css";
import "@fontsource/outfit/800.css";
import "@fontsource/ibm-plex-sans/300.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-sans/700.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@/index.css";
import App from "@/App";

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
const rootElement = document.getElementById("root");

if (window.location.pathname !== "/") {
  document.getElementById("homepage-prerender")?.remove();
}

const root = ReactDOM.createRoot(rootElement);
root.render(app);
